import React from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  DocumentTextIcon,
  // ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline";
import { ReportStatusEnum } from "../helper/constant";

interface WeekPickerProps {
  report_statuses_id: boolean;
  showapproveReject: boolean;
  report_id: number | null;
  userType: string;
  selectedWeek: Date;
  setSelectedWeek: React.Dispatch<React.SetStateAction<Date>>;
  onNextWeek: () => void;
  onPrevWeek: () => void;
  onSave: () => void;
  onSubmitToApproval: () => void;
  onExport: () => void;
  isNextWeekDisabled: boolean;
  showExportButtons: boolean;
}

const WeekPicker: React.FC<WeekPickerProps> = ({
  report_statuses_id,
  report_id,
  userType,
  showapproveReject,
  selectedWeek,
  setSelectedWeek,
  onNextWeek,
  onPrevWeek,
  onSave,
  onSubmitToApproval,
  onExport,
  isNextWeekDisabled,
  showExportButtons
}) => {
  const startOfWeek = (date: Date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - newDate.getDay());
    return newDate;
  };

  const endOfWeek = (date: Date) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - newDate.getDay() + 6);
    return newDate;
  };

  const handlePrevWeek = () => {
    setSelectedWeek((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(newDate.getDate() - 7);
      return startOfWeek(newDate);
    });
    onPrevWeek();
  };

  const handleNextWeek = () => {
    const currentDate = new Date();
    const nextWeek = new Date(selectedWeek);
    nextWeek.setDate(nextWeek.getDate() + 7);
    const check = nextWeek > currentDate;
    if (!isNextWeekDisabled && !check) {
      setSelectedWeek((prev) => {
        const newDate = new Date(prev);
        newDate.setDate(newDate.getDate() + 7);
        return startOfWeek(newDate);
      });
      onNextWeek();
    }
  };

  const formattedStartDate = startOfWeek(selectedWeek).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const formattedEndDate = endOfWeek(selectedWeek).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className=' md:flex items-center mb-4 justify-between  mx-auto'>
      {userType !== "finance" && (
        <div className='relative w-full md:max-w-sm mb-3 md:mb-0'>
          <button
            type='button'
            className='absolute inset-y-0 left-0 flex items-center pl-3'
            onClick={handlePrevWeek}
          >
            <ChevronLeftIcon className='h-5 w-5 text-blue-500' />
            {/* <span className="ml-2">Previous Week</span> */}
          </button>
          <input
            type='text'
            readOnly
            disabled
            value={`${formattedStartDate} - ${formattedEndDate}`}
            className='bg-gray-50 border text-center  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-10 mr-5 py-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
            required
          />
          <button
            type='button'
            className='absolute inset-y-0 right-0 flex items-center pr-3'
            onClick={handleNextWeek}
            disabled={isNextWeekDisabled}
          >
            {/* <span className="mr-2">Next Week</span> */}
            <ChevronRightIcon className='h-5 w-5 text-blue-500' />
          </button>
        </div>
      )}
      <div className='flex space-x-4 md:ml-4'>
        {userType !== "finance" && userType !== "manager" && !showapproveReject && report_statuses_id && (
          <button
            onClick={onSave}
            className='flex items-center px-4 py-2 text-sm bg-green-500 text-white rounded-lg focus:outline-none hover:bg-green-600'
          >
            <ArrowUpTrayIcon className='h-5 w-5 mr-2' />
            Save
          </button>
        )}
        {userType !== "finance" && userType !== "manager" && !showapproveReject && report_statuses_id && (
          <button
            onClick={onSubmitToApproval}
            className='flex items-center px-4 py-2 text-sm bg-yellow-500 text-white rounded-lg focus:outline-none hover:bg-yellow-600'
          >
            <DocumentTextIcon className='h-5 w-5 mr-2' />
            Submit For Approval
          </button>
        )}
        {!showExportButtons && report_id === ReportStatusEnum.Approved && (
          <button
            onClick={() => onExport()}
            className='flex items-center px-4 py-2 text-sm bg-blue-500 text-white rounded-lg focus:outline-none hover:bg-blue-600'
          >
            <ArrowDownTrayIcon className='h-5 w-5 mr-2' />
            Export PDF
          </button>
        )}

        {/* {userType === "finance" && (
          <button
            onClick={() => onExport()}
            className='flex items-center px-4 py-2 text-sm bg-blue-500 text-white rounded-lg focus:outline-none hover:bg-blue-600'
          >
            <ArrowDownTrayIcon className='h-5 w-5 mr-2' />
            Export PDF
          </button>
        )} */}
      </div>
    </div>
  );
};

export default WeekPicker;
